module.exports = "fragment LayoutFragment on Layout {\n  __typename\n  id\n  category\n  owner\n  dimensions\n  thumbnail {\n    url\n  }\n}\n"